import React, { useRef, useState } from "react";
import FacebookIcon from "../../assets/icons/svg/FacebookIcon";
import InstagramIcon from "../../assets/icons/svg/InstagramIcon";
import LinkedinIcon from "../../assets/icons/svg/LinkedinIcon";
import ShareIcon from "../../assets/icons/svg/ShareIcon";
import TwitterIcon from "../../assets/icons/svg/TwitterIcon";
import YayIcon from "../../assets/icons/svg/YayIcon";
import CopyIcon from "../../assets/icons/svg/CopyIcon";
import localizationStrings from "../../statics/localization";
import VisibilitySensor from "react-visibility-sensor";
import { copyToClipboard } from "../../utils/copyToClipboard";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from "react-share";
import WhatsappIcon from "../../assets/icons/svg/WhatsappIcon";
import EmailIcon from "../../assets/icons/svg/EmailIcon";

const ShareAction = ({
  vod,
  programInfo,
  isPlayer,
  selectedChannel,
  newVodDetail
}) => {
  const [showShareOptions, setShowShareOptions] = useState(false);
  const [isRight, setIsRight] = useState(false);
  const isVisibleRef = useRef(false);
  const [shareUrl, setShareUrl] = useState("");
  const [message, setMessage] = useState("");

  const shareClicked = () => {
    let dataInfo;
    if (selectedChannel?.id) {
      dataInfo = encodeURIComponent(`2|${selectedChannel?.id}`);
    } else {
      dataInfo = encodeURIComponent(`1|${vod?.id}`);
    }

    setMessage(
      localizationStrings.formatString(localizationStrings.shareText, {
        contentName: vod?.title ? `"${vod?.title}"` : `"${programInfo?.title}"`
      })
    );
    const shareUrl = selectedChannel?.id
      ? `${window.location.origin}/?datainfo=${dataInfo}`
      : `${window.location.origin}${window.location.pathname}#/dashboard/voddetail/${encodeURIComponent(vod?.id)}`;
    setShareUrl(shareUrl);
  };

  return (
    <div
      className={`action-button secondary ${
        showShareOptions ? "selected" : ""
      }`}
      style={showShareOptions ? { borderRadius: "50% 50% 50% 0" } : {}}
      onKeyDown={event => { if (event.key === "Escape") { event.stopPropagation(); setShowShareOptions(false); } }}
    >
      <button type="button" aria-label={localizationStrings.shareNow} aria-expanded={showShareOptions}
        style={{ background: "none", border: 0, color: "inherit", font: "inherit", display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => { shareClicked(); setShowShareOptions(value => !value); setIsRight(!isVisibleRef.current); }}>
      <span className="icon">
        <ShareIcon />
      </span>
      {newVodDetail && !showShareOptions ? (
        <span style={{ paddingLeft: "1vw" }} className={`action-label`}>
          {localizationStrings.shareNow}
        </span>
      ) : null}
      </button>
      {showShareOptions && <VisibilitySensor>
        {({ isVisible }) => {
          //isVisibleRef.current = isVisible;
          return (
            <div
              className={`custom-tooltip ${
                isRight && !newVodDetail ? "tooltip-right" : "tooltip-left"
              } ${showShareOptions ? "open" : ""}  ${
                isPlayer ? "player-tooltip" : ""
              }`}
            >
              {!isPlayer ? (
                <div className="tooltip-text">
                  {localizationStrings.shareNow}
                </div>
              ) : null}
              <div className="tooltip-button">
                <TwitterShareButton aria-label="X"
                  url={shareUrl}
                  title={message}
                  separator={`\n`}
                  windowHeight={450}
                  windowWidth={650}
                >
                  <span className="tooltip-icon">
                    <TwitterIcon />
                  </span>
                </TwitterShareButton>
              </div>
              <div className="tooltip-button">
                <WhatsappShareButton aria-label="WhatsApp"
                  url={shareUrl}
                  title="whatsapp"
                  quote={message}
                  separator={`\n`}
                  windowHeight={550}
                  windowWidth={650}
                >
                  <span className="tooltip-icon">
                    <WhatsappIcon />
                    {/* <WhatsappIcon
                      size={"100%"}
                      round={true}
                      bgStyle={{ fill: "white" }}
                      iconFillColor="black"
                      className="share-icon"
                    /> */}
                  </span>
                </WhatsappShareButton>
              </div>
              <div className="tooltip-button">
                <FacebookShareButton aria-label="Facebook"
                  url={shareUrl}
                  title="facebook"
                  quote={message}
                  separator={`\n`}
                  windowHeight={550}
                  windowWidth={650}
                >
                  <span className="tooltip-icon">
                    <FacebookIcon />
                  </span>
                </FacebookShareButton>
              </div>
              <div className="tooltip-button">
                <EmailShareButton aria-label="Email"
                  url={shareUrl}
                  subject={"Atlas V2 Share Content"}
                  body={message}
                  separator={`\n`}
                >
                  <span className="tooltip-icon">
                    <EmailIcon />
                  </span>
                </EmailShareButton>
              </div>

              {/* <div className="tooltip-button">
                <LinkedinShareButton
                  url={shareUrl}
                  title={message}
                  separator={`\n`}
                  windowHeight={450}
                  windowWidth={650}
                >
                  <span className="tooltip-icon">
                    <LinkedinIcon />
                  </span>
                </LinkedinShareButton>
              </div> */}
              <button type="button" aria-label={localizationStrings.copy || "Copy link"}
                className="tooltip-button"
                onClick={() => {
                  copyToClipboard(shareUrl);
                }}
              >
                <span className="tooltip-icon">
                  <CopyIcon />
                </span>
              </button>
              {/* <div className="tooltip-button">
                <span className="tooltip-icon">
                  <YayIcon />
                </span>
              </div> */}
            </div>
          );
        }}
      </VisibilitySensor>}
    </div>
  );
};

export default ShareAction;
